import React,{Component} from 'react';
import './App.css';
import './css/getComponents.css';
import './css/getVersion.css';
import './css/getComponents.scss';
import GetHome from './Components/getHome';
import GetHomeUser from './Components_users/getHomeUser';
import DashboardGerencial from "./pages/DashboardGerencial";
import EstadisticasLayout from "./pages/Estadisticas/EstadisticasLayout";



//import 'reflex-grid'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useParams
} from "react-router-dom";
import firebase from "firebase/app";
import "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyBfMxt2IQ6izSdYmQ-Ie0gKedPwD2PLzwU",
  authDomain: "app-delivery-8b998.firebaseapp.com",
  databaseURL: "https://app-delivery-8b998.firebaseio.com",
  projectId: "app-delivery-8b998",
  storageBucket: "app-delivery-8b998-60x60",
  messagingSenderId: "74232381793",
  appId: "1:74232381793:web:09303378ca795bdeb48520",
  measurementId: "G-9J0C50L1ES"
}
firebase.initializeApp(firebaseConfig)

const basepath = process.env.PUBLIC_URL
//let dir_url =  "http://192.168.43.218/neola/index.php/"
//let dir_url =  "http://192.168.0.104/neola/index.php/"
let dir_url =  "https://www.grupomn.net/app/lcr/api/index.php/"//"http://localhost/neola/index.php/"

class App extends Component {
  constructor(){
    super()
    this.state = {
        token : '',
        api_key_google :'',
        url_image:'',
        separator:'',
        file_60x60:'',
        file_250x200:'',
        file_500x200:'',
        file_250x250:'',
        database: 'none'
    }
    //console.log("ssssssssssssssssssss")
  }
  render (){
    var res = basepath.replace("https://www.grupomn.net", "")
    if(basepath!==''){
      dir_url =  basepath.replace("/web", "/api/index.php/")
    }
    if(this.state.token===''){
      return (<React.Fragment></React.Fragment>)
    }
    return (
      <Router>
          <Switch>
          <Switch>
            <Route path={res+"/:data_return"} children={<Home database={this.state.database} separator={this.state.separator} url_image={this.state.url_image} file_500x200={this.state.file_500x200} file_250x200={this.state.file_250x200}  file_60x60={this.state.file_60x60} file_250x250={this.state.file_250x250} token={this.state.token} api_key_google={this.state.api_key_google} />} />
          </Switch>
          </Switch>
      </Router>
    );
  }
  componentDidMount (){
    const url= dir_url + "webapp/getTemp";
    var obj = { accion:'getTemp'};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.setState({
        token:data[0].token,
        api_key_google:data[0].api_key_google,
        url_image:data[0].url_image,
        separator:data[0].separator,
        file_60x60:data[0].file_60x60,
        file_250x200:data[0].file_250x200,
        file_500x200:data[0].file_500x200,
        file_250x250:data[0].file_250x250,
        database:data[0].database
      })
    })
    .catch(console.log)
  }
}
export default App

function Home({database,separator,url_image,file_500x200,file_250x200,file_60x60,file_250x250,token,api_key_google}) {
  let { data_return } = useParams();
  if(!token){
    return (
      <React.Fragment></React.Fragment>
    )
  }else{
    let lat = 0
    let lon = 0
    let accion=''
    let sucursal
    let sentence = data_return.split(',')
    let id_mesa =0

    if(sentence.length===3){
      if((Number(sentence[1])>0||Number(sentence[1])<0)&&(Number(sentence[2])>0||Number(sentence[2])<0)){
          if(sentence[0]==='app'){
            accion='next_cliente'
            lat = Number(sentence[1])
            lon = Number(sentence[2])
          }
          if(sentence[0]==='usuario'){
            accion = "user"
            lat = Number(sentence[1])
            lon = Number(sentence[2])
          }

      }else{

      }
    }else{
      /* <DashboardGerencial
                  token={token}
                  database={database}
                  separator={separator}
                  url_image={url_image}
                />  */
        if(sentence.length===1){
            if (data_return === "gerentev1") {
              return (
                <React.Fragment>
                  <EstadisticasLayout />
                </React.Fragment>
              );
            }else{
              if(data_return==="usuario"){
                accion = "user"
              }
            }
        }else{
          if(sentence.length===2){
            if(sentence[0]==='sucursal'){
              accion ='next_cliente'
              sucursal = sentence[1]
              //lat = Number(sentence[1])
              //lon = Number(sentence[2])
            }
          }else{
            if(sentence.length===4){
              if(sentence[0]==='sucursal'&&sentence[2]==='mesa'){
                accion ='next_cliente'
                sucursal = Number(sentence[1])
                id_mesa =  Number(sentence[3])
              }
            }
          }
        }
    }
    if(accion===""){
      accion = "next_cliente"
    }

    let modulo_activo// = <React.Fragment><GetUploadImage width={'60px'} height={'60px'} token_image={''} /></React.Fragment>
    if(accion==='next_cliente'){
      modulo_activo =<React.Fragment><GetHome sucursal={sucursal} id_mesa={id_mesa} database={database} separator={separator} url_image={url_image}  firebase={firebase} file_500x200={file_500x200} file_250x200={file_250x200} file_250x250={file_250x250} file_60x60={file_60x60}  token={token} dir_url={dir_url} api_key_google={api_key_google} lat={lat} lon={lon} accion={accion} /></React.Fragment>
    }
    //console.log("HOME")
    if(accion==='user'){
      //console.log(token)
      modulo_activo =<React.Fragment><GetHomeUser database={database} separator={separator} url_image={url_image}  firebase={firebase} file_500x200={file_500x200} file_250x200={file_250x200} file_250x250={file_250x250} file_60x60={file_60x60} token={token} dir_url={dir_url} api_key_google={api_key_google} /></React.Fragment>
    }
    /*if(accion===''){
      modulo_activo =<React.Fragment><GetHome token={token} dir_url={dir_url} api_key_google={api_key_google}  lat={lat} lon={lon} accion={accion} /></React.Fragment>
    }*/

    return (
      <React.Fragment>
      {modulo_activo}
      </React.Fragment>
    )
  }
}
